import { useQuery } from '@tanstack/react-query';
import { useTranslation } from '@packlink/translation-provider';
import { COUNTRY_PREFIXES } from '../constants/country-prefixes.js';

const DEFAULT_LOCALE = 'en-GB';
function useCountryPrefixOptions(cdnUrl, clientAlpha2Code, enabled) {
  const {
    i18n: {
      language: locale
    }
  } = useTranslation();
  const getDefaultOption = options => {
    return options.find(option => option.alpha2Code === clientAlpha2Code);
  };
  const {
    data: prefixOptions,
    isLoading,
    isSuccess
  } = useQuery({
    queryKey: ['countryPrefixOptions', cdnUrl],
    queryFn: () => fetch(`${cdnUrl}/apps/countries/countries.json`).then(res => res.json()),
    enabled,
    select: data => {
      return COUNTRY_PREFIXES.reduce((result, alpha2Code) => {
        const country = data.values[alpha2Code];
        if (country) {
          return result.concat({
            label: (country.name[locale] || country.name[DEFAULT_LOCALE]) + ` (${country.phonePrefix})`,
            value: country.phonePrefix,
            alpha2Code
          });
        }
        return result;
      }, []);
    }
  });
  return {
    options: prefixOptions || [],
    defaultValue: getDefaultOption(prefixOptions || []),
    isLoading,
    isSuccess
  };
}

export { useCountryPrefixOptions };
//# sourceMappingURL=useCountryPrefixOptions.js.map
